// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gbl1","colBig":"styles_colBig__3MZTq","colSmall":"styles_colSmall__3sHMM","shopifyNameWrapper":"styles_shopifyNameWrapper__2rfzk"};